import { useTenantsStore } from '@/stores/tenants';

const isTenantVerified = () => !!useTenantsStore().currentTenantDetails?.verifiedAt;

export default isTenantVerified;
